import React, { memo as Memo, useMemo, useEffect, useRef, useState } from 'react'

//* HOC's
import { withDataContext, withLanguageContext } from 'context'

//* Components
import { Container, Text, AnimationWrapp, Page, Icon } from 'components/common'
import { TicketsTab } from 'components/pages'

//* Styles
import TicketsStyle from 'styles/pages/TicketsStyle'

const Tickets = Memo(({ global, selectedLang, pages, pageParams }) => {
	//! States
	const [secObj, setSecObj] = useState()
	const [tabActive, setTabActive] = useState(1)
	const [secTopObj, setSecTopObj] = useState()
	const [startAnimation, setStartAnimation] = useState(false)

	//! Page Data
	const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])
	const globallData = useMemo(() => global?.[selectedLang], [global, selectedLang])

	//! Refs
	const titleRef = useRef()
	const tabRef = useRef()
	const contRef = useRef()

	useEffect(() => {
		if (pageData && contRef?.current && titleRef?.current && tabRef?.current) {
			setSecTopObj(contRef.current)
			setSecObj([titleRef.current, tabRef.current.childNodes, '.fromLeft', '.otherElementAnimation'])
		}
	}, [titleRef, tabRef, pageData, globallData, tabActive, selectedLang])

	const StartAnim = (x) => {
		setStartAnimation(!!x)
	}

	return (
		<Page className='tickets'>
			{pageData && globallData ? (
				<AnimationWrapp
					state={secObj}
					sectionTop={secTopObj}
					sectionAnimationStart={(e) => StartAnim(e)}
					animationDuration={0.3}
					animationStagger={0.04}
				>
					<TicketsStyle>
						<Container className='containerPaddTop containerPaddBottom'>
							<div className='FlexBoxContainer  margBottomTitle'>
								<Text ref={titleRef} tag={'h4'} className={'singleTitle GHEAMariamBold uppercase'} text={'TicketsInformation'} />
							</div>

							<div className='ticketsWrapp FlexBoxContainer alignCenter spaceBetween'>
								<div className='leftWrapp'>
									<div className='tabWrapp FlexBoxContainer overflowHidden' ref={tabRef}>
										<div
											className={`tabTitle description textAlignCenter cursorPointer ${tabActive == 1 ? 'active' : ''}`}
											onClick={(e) => setTabActive(1)}
										>
											<Text tag={'p'} className={' pL NotoSansRegular uppercase'} text={'NonResidents'} />
										</div>
										<div
											className={`tabTitle description textAlignCenter cursorPointer ${tabActive == 2 ? 'active' : ''}`}
											onClick={(e) => setTabActive(2)}
										>
											<Text tag={'p'} className={' pL NotoSansRegular uppercase'} text={'Residents'} />
										</div>
									</div>
									<div className='tabItemWrapp relativeWrapp'>
										<TicketsTab
											tabActive={tabActive == 1}
											data={pageData.content.no_resident}
											freePolicy={pageData.content.no_resident_free_policy}
										/>
										<TicketsTab
											tabActive={tabActive == 2}
											data={pageData.content.resident}
											typeResidents={true}
											freePolicy={pageData.content.resident_free_policy}
										/>
									</div>
								</div>

								<div className={'rightWrapp'}>
									<div className={`right ${startAnimation ? 'active' : ''}`} ref={contRef}>
										<div className='FlexBox alignCenter '>
											<Icon className={'icon-star2 h4'} />
										</div>

										<div className='allInformation margBottomTitle'>
											<div>
												<Text
													tag={'p'}
													className={'pL GHEAMariamBold margBottomTitle uppercase'}
													text={'TicketAvailableMuseum'}
												/>
											</div>

											<Text tag={'p'} className={'allInformationTitle pL GHEAMariamBold uppercase'} text={'Open'} />
											<Text tag={'p'} className={'pL NotoSansRegular'} text={globallData.opening_hours} />
										</div>
										<div className='allInformation margBottomTitle'>
											<Text tag={'p'} className={'allInformationTitle pL GHEAMariamBold uppercase'} text={'Address'} />
											<Text tag={'p'} className={'pL NotoSansRegular'} text={globallData.address} />
										</div>
										<div className='allInformation margBottomTitle'>
											<Text tag={'p'} className={'allInformationTitle pL GHEAMariamBold uppercase'} text={'Reservaion'} />

											<a
												href={`mailto:${globallData.email}`}
												target='_blank'
												rel='noopener noreferrer'
												className='pL NotoSansRegular'
											>
												{globallData.email}
											</a>
											<br />
											<a
												href={`tel:${globallData.phones[0]}`}
												target='_blank'
												rel='noopener noreferrer'
												className='pL NotoSansRegular'
											>
												{globallData.phones}
											</a>
										</div>
										<div className='allInformation margBottomTitle'>
											<Text
												tag={'p'}
												className={'allInformationTitle pL GHEAMariamBold uppercase'}
												text={'VisitingInformation'}
											/>
											<Text tag={'p'} className={'pM NotoSansRegular'} text={globallData.text} />
										</div>
									</div>
								</div>
							</div>
						</Container>
					</TicketsStyle>
				</AnimationWrapp>
			) : (
				''
			)}
		</Page>
	)
})

export default withLanguageContext(withDataContext(Tickets, ['global', 'pages']), ['selectedLang'])
